import { useQuery } from "@tanstack/react-query";

import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import getQueryKeys from "common/datahooks/getQueryKeys";
import { get } from "common/helpers/HTTP";

// if nothing is selected we will get null instead of an empty string
async function getSalesNavigatorContract(
  workspaceId: string,
  accountId: string,
): Promise<string | null> {
  return (
    await get(
      `workspaces/${workspaceId}/accounts/${accountId}/sales-navigator/selected-seat`,
    )
  ).selected_seat;
}

export default function useSalesNavigatorContract(accountId: string) {
  const { id: workspaceId } = useSelectedWorkspaceContext();

  const { accountsKeys } = getQueryKeys(workspaceId);

  const {
    data: salesNavigatorContract,
    isLoading: isLoadingSalesNavigatorContract,
  } = useQuery({
    queryKey: accountsKeys.salesNavigatorContract(accountId),
    queryFn: () => getSalesNavigatorContract(workspaceId, accountId),
  });

  return { salesNavigatorContract, isLoadingSalesNavigatorContract };
}
